import React, { useEffect } from "react"
import FlexBox from "../../schoolUiComponents/basic/Box/FlexBox"
import PopupViewer from "../../schoolUiComponents/PopupViewer"
import { Colors } from "../../baseStyles/enums/colors"
import Image from "../../schoolUiComponents/basic/Image"
import Text from "../../schoolUiComponents/basic/Text"
import SuccessIcon from "../assets/success-icon.svg"
import PositionBox from "../../schoolUiComponents/basic/Box/PositionBox"
import Fonts from "../../baseStyles/enums/fonts"
import MergeStudentStyles from "./styles"
import { viewedPtlStudentLinkedSuccessfullyPopupEvent } from "../events"
import { IChild, IReferralData } from "."
import StringUtility from "utility/string"
import { ImageUtility } from "utility/images"


export const SuccessPopup = ( { child, popupCloseCallback, existingChild, optionSelected, referralData } : { child: IChild, popupCloseCallback: () => void, existingChild: IChild[], optionSelected: string, referralData: IReferralData }) => {

  const styles = MergeStudentStyles();
  useEffect(() => {
    viewedPtlStudentLinkedSuccessfullyPopupEvent({ linkedStudentCount: existingChild.length.toString(), optionsSelected: [optionSelected], grade: child.grade_code, ...referralData });
  }, [])

  return (
    <PopupViewer 
      closeCallback={popupCloseCallback}
      autoClose={true}
      showCrossIcon={false}
      // @ts-ignore
      padding={styles.successPopupWrap.padding}
      autoCloseTimeout={5000}
    >
      <FlexBox column gap={36} {...styles.successPopup}>
        <FlexBox column width={156} padding={"12px 12px 32px 12px"} gap={8} borderRadius={16} backgroundColor={Colors.WHITE_2} relative>
          {/* @ts-ignore */}
          <Image 
            src={child?.show_gamification_avatar ? child.avatar : (ImageUtility.avatars as any)[`avatars/child-${child.avatar}.png`]} 
            width={48} 
            height={48} 
            {...(child?.show_gamification_avatar && { borderRadius: "50%" })}
          />
          <FlexBox column gap={4} fullWidth>
              <Text.NORMAL color={Colors.BLACK} emphasis fullWidth lines={2}>{StringUtility.formatFullName(child.first_name, child.last_name)}</Text.NORMAL>
              {!!child?.grade && <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY}>{child.grade}</Text.SMALL>}
          </FlexBox>
          <PositionBox.absolute bottom={-20}> <SuccessIcon/> </PositionBox.absolute>
        </FlexBox>
        <FlexBox column gap={8}>
          <Text.H2 emphasis>Linked successfully</Text.H2>
          <Text.H4 color={"rgba(26, 26, 26, 0.50)"} fontWeight={Fonts.Weight.W400}>Redirecting to dashboard...</Text.H4>
         </FlexBox>
      </FlexBox>


    </PopupViewer>
  )
}